import React from "react";
import { statusStyles } from "@/theme/themeTokens";

const labelize = (s) =>
  (s || "").replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

export function StatusBadge({ status, testid }) {
  const cls = statusStyles[status] || statusStyles.inactive;
  return (
    <span
      data-testid={testid || `status-badge-${status}`}
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold ${cls}`}
    >
      {labelize(status)}
    </span>
  );
}

export function VenueBadge({ venueType }) {
  if (!venueType) return null;
  return (
    <span className="inline-flex items-center rounded-md border border-slate-200 bg-slate-50 px-2 py-0.5 text-xs font-medium text-slate-600">
      {labelize(venueType)}
    </span>
  );
}

export { labelize };
